<!-- Overlay to prevent background interactions -->
<div class="banner-overlay" *ngIf="showBanner"></div>

<div class="smart-app-banner" *ngIf="showBanner">
  <div class="banner-wrapper">
    <div class="banner-content">
      <!-- App Avatar Section -->
      <div class="app-avatar">
        <div class="avatar-container">
          <div class="avatar-background">
            <img src="../../../assets/img/uniqode-app.svg" alt="Uniqode Cards App" class="app-icon" />
          </div>
        </div>
      </div>

      <!-- Text Information Section -->
      <div class="text-section">
        <div class="app-name">Uniqode Cards</div>
        <div class="app-developer">Uniqode Phygital, Inc</div>
      </div>

      <!-- Close Button -->
      <button class="close-button" (click)="onCloseBanner()" aria-label="Close banner">
        <img src="../../../assets/img/close-icon.svg" alt="Close" class="close-icon" />
      </button>
    </div>

    <!-- Download Button -->
    <button class="download-button" (click)="onDownloadApp()">
      {{ downloadButtonText }}
    </button>
  </div>
</div> 